import {
  Directive,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
  ElementRef,
} from '@angular/core';

@Directive({
  selector: 'button[loadingButton]',
})
export class LoadingButtonDirective implements OnChanges {
  @Input() loading = false;
  @Input() disabled = false;

  private spinnerElement: HTMLElement | null = null;
  buttonContent = null;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['loading']) {
      if (this.loading) {
        this.showSpinner();
        this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'true');
      } else {
        this.hideSpinner();
        if (!this.disabled) {
          this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
        }
      }
    }
  }

  private showSpinner(): void {
    if (!this.spinnerElement) {
      this.buttonContent = this.el.nativeElement.innerHTML;
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', 'loading...');
      this.spinnerElement = this.renderer.createElement('span');
      this.renderer.addClass(this.spinnerElement, 'spinner');
      this.renderer.appendChild(this.el.nativeElement, this.spinnerElement);
     
    }
  }

  private hideSpinner(): void {
    if (this.spinnerElement) {
      this.renderer.removeChild(this.el.nativeElement, this.spinnerElement);
      this.spinnerElement = null;
      this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.buttonContent);
     
    }
  }
}
